import { render } from "./ProjectIcon.vue?vue&type=template&id=73bb5c1b&scoped=true"
import script from "./ProjectIcon.vue?vue&type=script&lang=js"
export * from "./ProjectIcon.vue?vue&type=script&lang=js"

import "./ProjectIcon.vue?vue&type=style&index=0&id=73bb5c1b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73bb5c1b"]])

export default __exports__